import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              平台优势
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              为什么数千万用户选择海角网
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {featureItems.map((item, idx) => (
              <div
                key={item.id}
                className="group p-6 rounded-2xl bg-background-50 border border-background-200/60 text-center cursor-default hover:border-primary-200 transition-all"
              >
                <div className={`w-14 h-14 mx-auto flex items-center justify-center rounded-2xl ${
                  idx % 3 === 0 ? 'bg-primary-100 text-primary-600' :
                  idx % 3 === 1 ? 'bg-accent-100 text-accent-600' :
                  'bg-secondary-100 text-secondary-600'
                }`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-4 text-sm font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}